import { handleEncoding } from "./handleEncoding";
import { titleCleanup } from "../templates/titleCleanup";

export const handleTitle = text => {
  const title = handleEncoding(text);
  const cleanup = titleCleanup(title);
  return cleanup;
};
